export const faqs = [
  {
    title: "What is Tanaad Money Services Online and Mobile App?",
    content:
      "Tanaad Money Online and Mobile App is a secure and easy-to-use, online and Mobile App money transfer service. Tanaad Send Money Online or Mobile app enables you to send money using your Debit/credit card.",
    extra_content: "",
    list: [],
    note: "",
    bottom_info: "",
  },
  {
    title: "What are Tanaad Transfer Services?",
    content: "Tanaad Money Transfer Services are:",
    extra_content: "",
    list: [
      "Cash pick up Transfer-funds can be collected from Tanaad designated collection points",
      "Bank account deposit Transfer-you can transfer money direct into local currency account",
      "Mobile Money Transfer-transfer money direct mobile wallet",
    ],
    note: "",
    bottom_info: "",
  },
  {
    title: "Where can I send money to with Tanaad?",
    content:
      "With Tanaad, you can send money to Kenya, Somalia, Ethiopia and Many more.",
    extra_content: "",
    list: [],
    note: "",
    bottom_info: "",
  },
  {
    title: "What are the benefits of Tanaad Sending Money Online?",
    content:
      "The key benefits of the Using Tanaad services Money Online and Mobile App Service are:",
    extra_content: "",
    list: [
      "Speed, Convenience, best exchange rate and low fees – because the service is available online and Mobile App, you may send money without having to visit a bank branch.",
    ],
    note: "",
    bottom_info: "",
  },
  {
    title: "What do I require to use Tanaad to Send Money Online?",
    content: "The Tanaad Money Online Service and Mobile App is easy to use",
    extra_content: "",
    list: [
      "You need an email address and mobile number: Make sure you use an email address and mobile number that you can easily remember and access. Either of this will be your username",
      "Password- For new customers you will have to create your own password during registration. For existing customer this will be generated by the system uniquely for you. You can however change it to something you can easily remember.",
      "Contact address information",
      "Date of birth and Identifications such as Valid Passport and Driving licence",
    ],
    note: "Note: For your first money transfer, you will be required to register before you can login to send money",
    bottom_info: "",
  },
  {
    title:
      "What does the beneficiary require to collect money sent through Tanaad Money Online?",
    content: "Beneficiary (receiver) requirements",
    extra_content: "",
    list: [
      "The Transfer Reference number",
      "A valid ID (passport, driving licence, ) to submit at the pay-out location to enable successful collection of money transferred to them.",
    ],
    note: "Note: For your first money transfer, you will be required to register before you can login to send money",
    bottom_info:
      "Within an hour beneficiary can collect money from our affiliates pay out.",
  },
  {
    title: "How do I register for the Tanaad to Send Money Online Service?",
    content:
      "You register for the Tanaad to Send Money Online Service by following the steps outlined below",
    extra_content: "FIRST TIME REMITTERS OF Tanaad – HOW DO I REGISTER",
    list: [
      "New User Registration (never used Tanaad before)",
      "Fill in all mandatory fields marked **,",
      "Step 1: Click on the ‘Sign up’ button.",
      "Step 2: Fill in your personal details/contact details and password,",
      "Step 3: Follow the on-screen instructions to complete your registration",
    ],
    note: "",
    bottom_info: "",
  },
  {
    title: "How do I send money using Tanaad to Send Money Online?",
    content:
      "After successful registration you will need your email address or your mobile number as your username and your password to login.",
    extra_content: "",
    list: [
      "Click on Sign in at the top right of Tanaad website or on your Tanaad Mobile app",
      "Select which of your username you will want to use email address or mobile number.",
      "Fill in your Username and Password",
      "Click on Login or Sign in",
      "Create a new beneficiary or select your existing beneficiary from the list.",
      "Follow the on-screen instructions to complete your transaction",
    ],
    note: "",
    bottom_info:
      "When a transaction is completed successfully you should find the Reference to share with your Receiver.",
  },
  {
    title: "Can I send money into a beneficiary’s bank account?",
    content:
      "Yes, all you need is beneficiary account number, bank name and bank branch.",
    extra_content: "",
    list: [],
    note: "",
    bottom_info: "",
  },
  {
    title: "What are the Tanaad Sending Money Online Service fees & charges?",
    content:
      "You will be informed of the transfer charges for sending money using Tanaad to Send Money Online, and the exchange rate used to derive the estimated amount that your beneficiary will receive in the designated currency before you proceed to confirm and save your transaction.",
    extra_content: "",
    list: [],
    note: "",
    bottom_info: "",
  },
];
